import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import { breakpoints, bicentennialSwiperConfig, debounce } from '../../helpers/index';

Swiper.use([Navigation, Pagination, A11y]);

class CrossLinkBlock extends Component {
  setupDefaults() {
    this.dom = {
      swiperContainer: this.el.querySelector(
        '.swiper-container'
      ),
      swiperSlides: this.el.querySelectorAll(
        '.swiper-slide'
      ),
      swiperPagination: this.el.querySelector(
        '.swiper-pagination'
      ),
      swiperButtonPrev: this.el.querySelector(
        '.swiper-btn-prev'
      ),
      swiperButtonNext: this.el.querySelector(
        '.swiper-btn-next'
      ),
      swiperControls: this.el.querySelector(
        '.swiper-controls'
      )
    };
    this.initSlider();
  }

  toggleNavigation(swiper) {
    if (swiper.isLocked) {
      this.dom.swiperControls.style.display = 'none';
    } else {
      this.dom.swiperControls.style.removeProperty('display');
    }
  }

  initSlider() {
    const totalPanels = this.dom.swiperSlides.length;
    const config = bicentennialSwiperConfig;

    this.swiper = new Swiper(this.dom.swiperContainer, {
      ...config,
      breakpoints: {
        [breakpoints.tablet]: {
          slidesPerView: totalPanels > 2 ? 2 : totalPanels,
          slidesPerGroup: totalPanels > 2 ? 2 : totalPanels
        
        },
        [breakpoints.tabletLandscape]: {
          slidesPerView: totalPanels
        }
      },
      navigation: {
        prevEl: this.dom.swiperButtonPrev,
        nextEl: this.dom.swiperButtonNext
      },
      a11y: {
        prevSlideMessage: this.el.dataset.previousSlideAriaLabel,
        nextSlideMessage: this.el.dataset.nextSlideAriaLabel
      },
      pagination: {
        el: this.dom.swiperPagination,
        clickable: true,
      },
      on: {
        init: this.toggleNavigation.bind(this),
        resize: () => debounce(this.toggleNavigation.bind(this), 100)
      }
    });

  }
}

export default CrossLinkBlock;
